import React from "react";

const VideoPlayer = (props) => {
  // Constant values for title and description

  const videoTitle =
    props.match.params.AppId === "6791c1e0ef1fe5183be52ce8"
      ? "Qatar Equestrian Federation (QEF)"
      : "";
  const videoDescription =
    props.match.params.AppId === "6791c1e0ef1fe5183be52ce8"
      ? "Watch live races and exclusive equestrian content from the Qatar Equestrian Federation."
      : "";
  const videoSource =
    props.match.params.AppId === "6791c1e0ef1fe5183be52ce8"
      ? "https://www.golfsaudi.com/storage/2024-04-15/gARtzSL8Hb7La9LWmKxI6HBDxxgl5r6SW15Xu2dJ.mp4"
      : props.match.params.AppId === "67b6ac45984a830020a10f2f"
      ? "https://devlqc.citrusdev.com/files/QEF-Facilities.mp4"
      : props.match.params.AppId === "67b80532984a830020a11eae"
      ? "https://devlqc.citrusdev.com/files/al-araby-network.mp4"
      : props.match.params.AppId === "67bedfa6984a830020a13304"
      ? "https://devlqc.citrusdev.com/files/bahrin-news.mp4"
      : "";

  return (
    <div style={{ position: "relative", width: "100%", height: "700px" }}>
      {/* Background Video */}

      {videoSource && (
        <video
          width="100%"
          height="700px"
          autoPlay
          loop
          muted
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover", // Ensures video covers the container
            zIndex: -1, // Keeps the video in the background
          }}
        >
          <source src={videoSource} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
      {/* Overlay Content */}
      <div
        style={{
          position: "absolute",
          bottom: "20px", // Aligns content near the bottom
          left: "20px", // Aligns content to the left
          color: "white",
          textAlign: "left",
          zIndex: 1,
          padding: "70px",
          maxWidth: "1000px",
        }}
      >
        <h1
          style={{
            fontSize: "50px",
            fontWeight: "bold",
            margin: 0,
            color: "#A2D2FF",
          }}
        >
          {videoTitle}
        </h1>
        <p
          style={{
            fontSize: "20px",
            lineHeight: "1.5",
            marginTop: "10px",
            marginBottom: 0,
          }}
        >
          {videoDescription}
        </p>
      </div>
    </div>
  );
};

export default VideoPlayer;
